export default "__VITE_ASSET__P95srVUE__"